import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IGeneralMessage } from '../../../../model/general-message';

@Component({
    selector: 'app-general-message-dialog',
    templateUrl: './general-message-dialog.component.html',
    styleUrls: ['./general-message-dialog.component.scss']
})
export class GeneralMessageDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public generalMessage: IGeneralMessage) {}
}
